@if (!settingCostFields && !settingValueBreakdownFields) {
  <pp-new-dashlet-modal-dashlets
    [ppAssetId]="assetId"
    (ppAddDashlet)="addDashlet($event)"
  ></pp-new-dashlet-modal-dashlets>
}

@if (settingCostFields) {
  <pp-new-dashlet-modal-cost-fields
    [ppAssetId]="assetId"
    (ppAddDashlet)="addCostComparisonDashlet($event)"
    (ppGoBack)="setSettingCost(false)"
    [ppNewDashlet]="true"
  ></pp-new-dashlet-modal-cost-fields>
}

@if (settingValueBreakdownFields) {
  <pp-new-dashlet-modal-value-breakdown-fields
    [ppAssetId]="assetId"
    (ppAddDashlet)="addValueBreakdownDashlet($event)"
    (ppGoBack)="setSettingValueBreakdown(false)"
    [ppNewDashlet]="true"
  ></pp-new-dashlet-modal-value-breakdown-fields>
}
